import SubPageShell from "@/components/SubPageShell";
import PricingBlock from "@/components/PricingBlock";

export default function PricingPage() {
  return (
    <SubPageShell testId="pricing-page">
      {(config) => <PricingBlock tiers={config.tiers || []} />}
    </SubPageShell>
  );
}
